// extracted by mini-css-extract-plugin
module.exports = {"aniEGsapB1":"aniEGsapB1_aniEGsapB1__OY2pA"};